import { ReactNode, HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface RootProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Foco verde APCAP (telas de login/cadastro) */
  variant?: "default" | "auth";
}

export function Root({ variant = "default", className, ...props }: RootProps) {
  const focusAuth =
    "transition-[box-shadow,border-color] duration-200 focus-within:border-apcap/45 focus-within:shadow-[0_0_0_3px_rgba(1,88,50,0.12)]";
  const focusDefault =
    "focus-within:border-apcap/45 focus-within:ring-4 focus-within:ring-apcap/10 dark:focus-within:border-apcap dark:focus-within:ring-apcap/20";

  const baseAuth =
    "flex w-full items-center gap-2 rounded-xl border border-zinc-200 bg-white px-3.5 py-2.5 shadow-sm outline-none [&_input]:text-zinc-900 [&_input]:placeholder:text-zinc-500";
  const baseDefault =
    "flex w-full items-center gap-2 rounded-lg border border-zinc-300 px-3 py-2 shadow-sm outline-none dark:border-zinc-700 dark:bg-zinc-800";

  return (
    <div
      {...props}
      className={twMerge(
        variant === "auth" ? baseAuth : baseDefault,
        variant === "auth" ? focusAuth : focusDefault,
        className
      )}
    />
  );
}
